export default "__VITE_ASSET__sGI5vuqt__"